import React from 'react';

type Status =
  | 'confirmed' |'tentative' |'cancelled' |'needs_coverage' |'active' |'completed' |'open' |'in_progress' |'resolved' |'approved' |'pending' |'denied' |'needs_discussion';

interface StatusBadgeProps {
  status: Status;
  size?: 'xs' | 'sm';
}

const STATUS_CONFIG: Record<Status, { label: string; className: string }> = {
  confirmed: { label: 'Confirmed', className: 'bg-emerald-50 text-emerald-700' },
  tentative: { label: 'Tentative', className: 'bg-amber-50 text-amber-700' },
  cancelled: { label: 'Cancelled', className: 'bg-red-50 text-red-600' },
  needs_coverage: { label: 'Needs Coverage', className: 'bg-red-50 text-red-600' },
  active: { label: 'Active', className: 'bg-indigo-50 text-indigo-700' },
  completed: { label: 'Completed', className: 'bg-slate-100 text-slate-500' },
  open: { label: 'Open', className: 'bg-amber-50 text-amber-700' },
  in_progress: { label: 'In Progress', className: 'bg-blue-50 text-blue-700' },
  resolved: { label: 'Resolved', className: 'bg-emerald-50 text-emerald-700' },
  approved: { label: 'Approved', className: 'bg-emerald-50 text-emerald-700' },
  pending: { label: 'Pending', className: 'bg-amber-50 text-amber-700' },
  denied: { label: 'Denied', className: 'bg-red-50 text-red-600' },
  needs_discussion: { label: 'Needs Discussion', className: 'bg-purple-50 text-purple-700' },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-md
        ${config.className}
        ${size === 'xs' ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5'}
      `}
    >
      {config.label}
    </span>
  );
}